import { isLocal } from "src/utils/detectEnv";

export const getWebSocketUrl = (): string => {
  const stage = "gamma".toLowerCase();

  if (isLocal() || stage === "test") {
    return "ws://127.0.0.1:8080";
  }

  return `wss://alb.${stage}.na.safer-api.whs.amazon.dev`;
};
